module.exports = __webpack_public_path__ + "static/upgrade.feec49b6.png";